const B =
  "https://firebasestorage.googleapis.com/v0/b/myportfolio-a8344.appspot.com/o/";

const projects = [
  {
    id: "neon-remote",
    index: "01",
    title: "Neon Remote",
    platformsLabel: "WEB · DESKTOP",
    image:
      B +
      "previews%2FScreenshot%20from%202025-02-28%2015-33-56.png?alt=media&token=bbf3b17b-fc52-4b95-8a33-c258bf3706ef",
    cardDescription:
      "Peer-to-peer storage that lets users reach their files across devices remotely — no cloud required.",
    cardTags: ["React", "TypeScript", "Electron", "Node"],
    live: "https://remote.neonsystems.net/",
    repo: "https://github.com/PaoloGuimalan/NeonRemote",
    description: [
      "A project that powers Neon Service's peer-to-peer storage, where users can access their files across different devices remotely without needing cloud storage.",
    ],
    categories: [
      "React JS",
      "TypeScript",
      "MongoDB",
      "CSS",
      "HTML",
      "Node JS",
      "Rest API",
      "Express JS",
      "Redux",
      "Electron JS",
    ],
    gallery: [
      {
        link:
          B +
          "gallery%2FScreenshot%20from%202025-02-28%2015-34-09.png?alt=media&token=68fbde68-47be-4796-bd36-91555e8ef21e",
      },
      {
        link:
          B +
          "gallery%2FScreenshot%20from%202025-02-28%2015-34-21.png?alt=media&token=a663c8f2-bcc1-44f1-914d-11e4867e068c",
      },
    ],
    platforms: [
      {
        platform_name: "Web",
        platform_title: "Remote Access",
        platform_desc:
          "The web access for users where they can open devices remotely.",
        platform_repo: "https://github.com/PaoloGuimalan/NeonRemote",
        platform_site: "https://remote.neonsystems.net/",
      },
      {
        platform_name: "Desktop",
        platform_title: "Service",
        platform_desc:
          "A desktop app/service installed and run in the background for realtime remote data communication.",
        platform_repo: "https://github.com/PaoloGuimalan/NeonRemote_Host",
        platform_site: "none",
      },
    ],
  },
  {
    id: "qc-bustrack",
    index: "02",
    title: "Quezon City BusTrack",
    platformsLabel: "WEB · ANDROID",
    image:
      B +
      "previews%2FScreenshot%202025-02-22%20135008.png?alt=media&token=2f16d73c-590e-4883-baad-9c0b82de53b3",
    cardDescription:
      "Live bus and passenger tracking for QC's Libre Sakay — monitored stats that improve the service.",
    cardTags: ["React", "Node", "MongoDB", "React Native"],
    live: "https://bustrackadmin.netlify.app/",
    repo: "https://github.com/PaoloGuimalan/TranspoTrack",
    description: [
      "A project dedicated to Quezon City's Libre Sakay, tracking buses and waiting passengers for more monitored statistics — improving the service's effectiveness.",
    ],
    categories: [
      "React JS",
      "MongoDB",
      "CSS",
      "HTML",
      "Node JS",
      "Rest API",
      "Express JS",
      "Redux",
      "React Native",
    ],
    gallery: [],
    platforms: [
      {
        platform_name: "Web",
        platform_title: "Admin",
        platform_desc:
          "Admin side where the TTMD (Traffic and Transport Management Department) manages traffic, buses, and station data. To try it: AdminID admin_098766 · Password dt187.",
        platform_repo: "https://github.com/PaoloGuimalan/TranspoTrack",
        platform_site: "https://bustrackadmin.netlify.app/",
      },
      {
        platform_name: "Android",
        platform_title: "Mobile",
        platform_desc:
          "Mobile app for commuters that tracks bus availability and time of arrival.",
        platform_repo:
          "https://github.com/PaoloGuimalan/QCBTS_Commuter_MobileApp",
        platform_site: "none",
      },
    ],
  },
  {
    id: "chatterloop",
    index: "03",
    title: "Chatterloop",
    platformsLabel: "WEB · ANDROID",
    image:
      B +
      "previews%2FChatterLoop.png?alt=media&token=cc99feab-db71-4c15-84d7-adb4d9973713",
    cardDescription:
      "A social app with a map-based feed and AI-assisted chat — browse posts across the world, not just a timeline.",
    cardTags: ["React/TS", "FastAPI", "Redis", "Flutter"],
    live: "https://chatterloop.app/",
    repo: "https://github.com/PaoloGuimalan/chat_app_client",
    description: [
      "Chatterloop is a social media web app I built for messaging and feed sharing. Unlike others, it has a Map Feed — instead of scrolling your feed the normal way, you browse feeds using maps and scroll posts from around the world.",
    ],
    categories: [
      "React JS/TS",
      "TypeScript",
      "MongoDB",
      "PostgreSQL",
      "Redis",
      "Node JS",
      "Express JS",
      "Redux",
      "Python",
      "FastAPI",
      "Django",
      "RabbitMQ",
      "Flutter",
    ],
    gallery: [],
    platforms: [
      {
        platform_name: "Web",
        platform_title: "Main System",
        platform_desc:
          "Similar to existing messaging platforms, hosted as a web app usable on any platform through browsers.",
        platform_repo: "https://github.com/PaoloGuimalan/chat_app_client",
        platform_site: "https://chatterloop.app/",
      },
      {
        platform_name: "Android",
        platform_title: "Mobile",
        platform_desc:
          "Mobile application (Flutter) with enhanced features and AI-assisted chat using large language models (gpt-4o-mini, llama-3.3-70b-versatile).",
        platform_repo: "https://github.com/PaoloGuimalan/chatterloop_mobile",
        platform_site: "none",
      },
    ],
  },
  {
    id: "coders-library",
    index: "04",
    title: "Coder's Library",
    platformsLabel: "WEB · ANDROID",
    image:
      B +
      "previews%2Fimg2.jpg?alt=media&token=d284dbfd-31cb-4b57-8857-2ffa8390331c",
    cardDescription:
      "A free, organized library of programming books — built during the pandemic to share resources with fellow learners.",
    cardTags: ["React", "Express", "MongoDB", "React Native"],
    live: "https://coderslibrary.netlify.app/",
    repo: "https://github.com/PaoloGuimalan/coderslibrary",
    description: [
      "Coder's Library was created mainly for sharing our team's gathered books. During the pandemic, we as learners struggled to find enough resources to learn programming, coding, and other IT topics — so our team began collecting free PDF books to share as a whole.",
      "The site was created in September 2021, built mainly with React JS and Node JS with Express. The server was deployed on Heroku and the frontend on Netlify. I made it to help friends and others gather resources for their studies.",
    ],
    categories: [
      "React JS",
      "CSS",
      "HTML",
      "Rest API",
      "React Native",
      "MongoDB",
      "Node JS",
      "SQLite",
      "Express JS",
      "Redux",
    ],
    gallery: [
      {
        link:
          B +
          "gallery%2Fproject_2_1.png?alt=media&token=8f3b9c6b-a65f-419d-8d8e-b3d328e154c3",
      },
      {
        link:
          B +
          "gallery%2Fproject_2_2.png?alt=media&token=052b9715-722a-4dc6-9716-d77cfb4a9c25",
      },
      {
        link:
          B +
          "gallery%2Fproject_2_3.png?alt=media&token=897796b4-fd98-4ce2-bd5a-15519a638b73",
      },
      {
        link:
          B +
          "gallery%2Fproject_2_4.png?alt=media&token=bc67d813-ef38-4073-ab7e-01a45ee34485",
      },
      {
        link:
          B +
          "gallery%2Fproject_2_5.png?alt=media&token=c3138a1b-ece8-42e5-82fe-99268aa5bea5",
      },
    ],
    platforms: [
      {
        platform_name: "Web",
        platform_title: "Main System",
        platform_desc:
          "The system consists of all the said functionalities, built as a web app with React JS.",
        platform_repo: "https://github.com/PaoloGuimalan/coderslibrary",
        platform_site: "https://coderslibrary.netlify.app/",
      },
      {
        platform_name: "Android",
        platform_title: "Mobile Application",
        platform_desc:
          "This sub-system has more features than the main system — users can create and log into accounts to save, tag, and manage books for an organized way of reading.",
        platform_repo: "https://github.com/PaoloGuimalan/coderslibrary_app",
        platform_site: "https://coderslibrary.netlify.app/android",
      },
    ],
  },
  {
    id: "transpotrack",
    index: "05",
    title: "TranspoTrack",
    platformsLabel: "WEB",
    image:
      B +
      "previews%2Fimg4.png?alt=media&token=8a7390c4-6725-4e7c-871f-e9098659c6d2",
    cardDescription:
      "Real-time public-transport tracking with Google Maps and WebSockets — connecting drivers and commuters to cut waiting time.",
    cardTags: ["React", "Node", "MongoDB", "WebSockets"],
    live: "https://transpotrack.netlify.app/",
    repo: "https://github.com/PaoloGuimalan/TranspoTrack",
    description: [
      "TranspoTrack uses Google Maps and Web Sockets to track public transportation and vice versa, whether you log in as a driver or a commuter. It reduces the hassle of waiting for public transport and helps drivers reduce waiting time for commuters — overall easing traffic density in the vicinity.",
    ],
    categories: [
      "React JS",
      "MongoDB",
      "CSS",
      "HTML",
      "Node JS",
      "Rest API",
      "Express JS",
      "Redux",
    ],
    gallery: [],
    platforms: [
      {
        platform_name: "Web",
        platform_title: "Main System",
        platform_desc:
          "This consists of everything in the system, since it is a web-based tracking system only.",
        platform_repo: "https://github.com/PaoloGuimalan/TranspoTrack",
        platform_site: "https://transpotrack.netlify.app/",
      },
    ],
  },
  {
    id: "encryption-lib",
    index: "06",
    title: "encryption.lib",
    platformsLabel: "LIBRARY",
    image:
      B +
      "previews%2Fimg3.jpg?alt=media&token=bce5c978-befe-4f43-8f0a-82ddc1a92480",
    cardDescription:
      "A JavaScript library — and its site — for layered client/server data encryption that other developers can drop into their projects.",
    cardTags: ["JavaScript", "React", "npm"],
    live: "https://encryptionlib.netlify.app/",
    repo: "https://github.com/PaoloGuimalan/encryption.lib_site",
    description: [
      "The site for a JavaScript library I developed for encrypting data that other developers can use. encryption.lib encrypts and decrypts data in your project, adding security and privacy — for example sending encrypted data from client to server so processed data is harder to read.",
      "It works in any web-based project, on both client and server sides, with levels of encryption to prevent encrypted data from being decrypted immediately.",
    ],
    categories: ["React JS", "CSS", "HTML", "Rest API", "JavaScript"],
    gallery: [],
    platforms: [
      {
        platform_name: "Web",
        platform_title: "Main Website",
        platform_desc:
          "The main website where you can find the JavaScript library.",
        platform_repo: "https://github.com/PaoloGuimalan/encryption.lib_site",
        platform_site: "https://encryptionlib.netlify.app/",
      },
    ],
  },
  {
    id: "neon-notes",
    index: "07",
    title: "Neon Notes",
    platformsLabel: "WEB",
    image:
      B +
      "previews%2Fneonnotesprev.png?alt=media&token=f67af740-e1ca-42a5-b403-7f090b23869a",
    cardDescription:
      "A Keep-style notes app built on ASP.NET MVC with Entity Framework — save, edit, and manage notes per account.",
    cardTags: ["ASP.NET", "C#", "MS SQL"],
    live: "http://neonnotes.somee.com/",
    repo: "https://github.com/PaoloGuimalan/NeonNotes",
    description: [
      "A website built with ASP.NET, Microsoft SQL, and Entity Framework. Similar to Google Keep, it lets users save, delete, and edit notes under their accounts — one of my demo systems using the ASP.NET MVC framework.",
    ],
    categories: [
      "ASP.Net",
      "Microsoft SQL",
      "HTML",
      "CSS",
      "C#/.NET Framework",
    ],
    gallery: [],
    platforms: [
      {
        platform_name: "Web",
        platform_title: "Main System",
        platform_desc: "The first and main system, accessible in any browser.",
        platform_repo: "https://github.com/PaoloGuimalan/NeonNotes",
        platform_site: "http://neonnotes.somee.com/",
      },
    ],
  },
  {
    id: "shopperia",
    index: "08",
    title: "Shopperia",
    platformsLabel: "WEB · MOBILE",
    image:
      B +
      "previews%2Fhome_logo.png?alt=media&token=92924753-efd4-4888-b8ce-e8491af25203",
    cardDescription:
      "An e-commerce platform with real-time parcel tracking on Maps, a rider app, and PayPal integration across three sub-systems.",
    cardTags: ["React", "React Native", "Node", "MySQL"],
    live: "none",
    repo: "https://github.com/PaoloGuimalan/Shopperia",
    description: [
      "Shopperia is an e-commerce platform that lets you order or buy products remotely. Unlike existing platforms, it lets users navigate and locate their orders or parcels using real-time tracking through Maps. Built with React JS and React Native, along with Node JS and PayPal integration.",
    ],
    categories: [
      "React JS",
      "React Native",
      "Node JS",
      "MySQL",
      "CSS",
      "HTML",
      "Rest API",
      "Express JS",
      "Redux",
    ],
    gallery: [
      {
        link:
          B +
          "gallery%2Fproject_6_1.png?alt=media&token=90605afb-d856-4859-83fd-a8ba0ae7cdd7",
      },
      {
        link:
          B +
          "gallery%2Fproject_6_2.png?alt=media&token=a0f61254-557f-4a0d-b411-6560da5cd843",
      },
      {
        link:
          B +
          "gallery%2Fproject_6_3.png?alt=media&token=99848fd2-3688-4b94-bbab-78049f0f0ce5",
      },
      {
        link:
          B +
          "gallery%2Fproject_6_4.png?alt=media&token=27850fb2-1035-47c4-a0c8-36ba2050d053",
      },
      {
        link:
          B +
          "gallery%2Fproject_6_5.png?alt=media&token=60cb5cba-aecd-433e-8d35-000e9ed3906f",
      },
      {
        link:
          B +
          "gallery%2Fproject_6_6.png?alt=media&token=c8571e37-8f52-486c-a92d-2a0738bec9b5",
      },
    ],
    platforms: [
      {
        platform_name: "Web",
        platform_title: "Buyer & Seller Side",
        platform_desc:
          "The primary sub-system for the buyer and seller to use and navigate.",
        platform_repo: "https://github.com/PaoloGuimalan/Shopperia",
        platform_site: "none",
      },
      {
        platform_name: "Web",
        platform_title: "Admin Side",
        platform_desc:
          "The customer support and parcel monitoring side — a separate sub-system so it can stand alone.",
        platform_repo: "https://github.com/PaoloGuimalan/Shopperia_Admin",
        platform_site: "none",
      },
      {
        platform_name: "Mobile",
        platform_title: "Rider Side",
        platform_desc:
          "A separate sub-system for riders, built as a cross-platform mobile app with React Native.",
        platform_repo:
          "https://github.com/PaoloGuimalan/Shopperia_App-RiderSide-",
        platform_site: "none",
      },
    ],
  },
  {
    id: "neon-xenon",
    index: "09",
    title: "Neon-Xenon Home",
    platformsLabel: "ANDROID",
    image:
      B +
      "previews%2FNeXePreview.png?alt=media&token=13484a84-a6cb-4413-9c32-635b877c96d4",
    cardDescription:
      "A Windows-11-inspired Android launcher with floating windows, PWA conversion, and live weather & news widgets.",
    cardTags: ["React Native", "SQLite", "Redux"],
    live: "none",
    repo: "https://github.com/PaoloGuimalan/NeonXenonHome",
    description: [
      "The second Android launcher/shell I created, made with React Native and built to stay responsive on any device. It features floating windows similar to a desktop OS, with a design inspired by Windows 11 — including weather and news updates via APIs, and the ability to turn web apps into progressive floating windows.",
      "Other features include screen-rotation support and, in terms of design, a taskbar and a start window to access installed apps.",
    ],
    categories: ["React Native", "SQLite", "Redux", "Rest API"],
    gallery: [],
    platforms: [
      {
        platform_name: "Android",
        platform_title: "Main Application",
        platform_desc:
          "The first version release of the app, installable on any Android device with ensured responsiveness.",
        platform_repo: "https://github.com/PaoloGuimalan/NeonXenonHome",
        platform_site: "none",
      },
    ],
  },
  {
    id: "accounting",
    index: "10",
    title: "University Accounting System",
    platformsLabel: "DESKTOP",
    image:
      B +
      "previews%2FAccounting%20System.png?alt=media&token=679e8de2-27f6-4f0d-8d41-80eb07f402bb",
    cardDescription:
      "A C# desktop app with a PHP + MySQL backend for monitoring and managing student accounts — a college systems project.",
    cardTags: ["C# / .NET", "PHP", "MySQL"],
    live: "none",
    repo: "https://github.com/PaoloGuimalan/SIA_AccountingSystem_Development",
    description: [
      "A college project designed for monitoring and managing student accounts at our university. Built as a C# Windows application integrated with a PHP server side and MySQL. It can integrate with different systems and is a responsive, well-designed Windows application.",
    ],
    categories: ["C#/.NET Framework", "MySQL"],
    gallery: [],
    platforms: [
      {
        platform_name: "Desktop",
        platform_title: "Main System",
        platform_desc:
          "This project is a sub-system only, and it is a desktop application.",
        platform_repo:
          "https://github.com/PaoloGuimalan/SIA_AccountingSystem_Development",
        platform_site: "none",
      },
    ],
  },
];

export default projects;

